import * as qs from "qs";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";
export function getFindJobsSearch(search, latitude,longitude,distance,salaryMin,salaryType,jobType,postedOn,workStatus,itemsPerPage) {
  return axiosInterceptors
    .get(
      ENV.alljobs_url +
      "employer/8ec4be9b-fc34-4091-9197-38b464fca462/jobs/active/",
      {
        params: {
          search: search,
          latitude:latitude,
          longitude:longitude,
          distance:distance,
          salaryMin:salaryMin,
          salaryType:salaryType,
          postedOn:postedOn,
          jobType:jobType,
          workStatus:workStatus,
          ps: itemsPerPage,
          
          // pn: currentPage,
          //   latitude:latitude,
          //   longitude:longitude
        },
        paramsSerializer: (params) => {
          var qps = qs.stringify(params, { arrayFormat: "repeat" });
          return qps;
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

